import GameBase from '../components/base/game-base';
import React from 'react';

const TourneysComponentsFormRulesPartGame = () => {
  return <GameBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartGame;
